import { render, staticRenderFns } from "./Make.vue?vue&type=template&id=ddd11502&scoped=true&"
import script from "./Make.vue?vue&type=script&lang=js&"
export * from "./Make.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd11502",
  null
  
)

export default component.exports